var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgApple = function SvgApple(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M9.995.007v9.802H0V.007h9.995z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.106)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#464646",
    d: "M8.347 3.756c-.013-1.635 1.27-2.42 1.327-2.458C8.952.188 7.83.035 7.428.017c-.955-.102-1.865.592-2.35.592-.483 0-1.232-.577-2.024-.561C2.01.064 1.05.685.514 1.667-.57 3.643.238 6.57 1.29 8.174c.516.784 1.13 1.667 1.938 1.634.778-.032 1.072-.529 2.012-.529.939 0 1.203.53 2.026.514.836-.017 1.367-.801 1.879-1.587.59-.91.835-1.791.85-1.837-.02-.009-1.632-.659-1.649-2.613",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#464646",
    d: "M6.802 2.063C7.231 1.517 7.52.757 7.44 0c-.617.026-1.364.433-1.808.98-.396.482-.744 1.255-.65 1.997.688.056 1.392-.369 1.82-.914"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgApple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/apple.c4243d2b029e4e71bf4c87ce6c2c7474.svg";